module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/extract-amd/a.js
 ** module id = 2
 ** module chunks = 0
 **/